export const downloads = {
  seo: {
    title: 'Downloads | Bistroo',
    description: 'Lade die Bistroo Manager App für iOS und Android herunter. Verwalte dein Restaurant ganz einfach von deinem Smartphone aus.',
  },
  title: 'Downloads',
  subtext: 'Auf dieser Seite findest du eine Übersicht aller Bistroo Manager Versionen',
  operating_system: {
    win: 'Windows',
    mac_os: 'Mac OSX',
  },
  supported_subversions: {
    win: 'Windows 7, Windows 8, Windows 10, Windows 11',
    mac_os: 'Ventura, Monterey, Big Sur',
  },

  btn_text: 'Herunterladen',

  latest_version_text:
    'Lade die neueste Version des Bistroo Managers für {os} herunter. Aktuell ist dies Version {version}',

  previous_versions_title: 'Frühere Versionen',
  previous_versions_subtext:
    'Auf dieser Seite findest du eine Übersicht aller Bistroo Manager Versionen',
}
